var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-popup/u-popup" */ "@/uni_modules/uview-ui/components/u-popup/u-popup.vue"
      )
    },
    uToolbar: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-toolbar/u-toolbar" */ "@/uni_modules/uview-ui/components/u-toolbar/u-toolbar.vue"
      )
    },
    uLoadingIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-loading-icon/u-loading-icon" */ "@/uni_modules/uview-ui/components/u-loading-icon/u-loading-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.$u.addUnit(_vm.visibleItemCount * _vm.itemHeight)
  var g1 = _vm.$u.addUnit(_vm.itemHeight)
  var l1 = _vm.__map(_vm.innerColumns, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g2 = _vm.$u.test.array(item)
    var g3 = g2 ? _vm.$u.addUnit(_vm.itemHeight) : null
    var g4 = g2 ? _vm.$u.addUnit(_vm.itemHeight) : null
    var l0 = _vm.__map(item, function (item1, index1) {
      var $orig = _vm.__get_orig(item1)
      var m0 = g2 ? _vm.getItemText(item1) : null
      return {
        $orig: $orig,
        m0: m0,
      }
    })
    return {
      $orig: $orig,
      g2: g2,
      g3: g3,
      g4: g4,
      l0: l0,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }